import { withData, WithDataDef, withIdRetrieval, WithIdRetrievalDef, withUoms, WithUomsDef } from './base-composer';
import { withCompanyContacts, WithCompanyContactsDef } from './company-contacts/company-contacts';
import { withAssociationMedia, withPrimaryImage } from './media/media';
import { PropertyRef, PropertyRefDef } from './property';

export interface AvailabilityDef extends WithIdRetrievalDef, WithUomsDef, WithDataDef, WithCompanyContactsDef {
  property: PropertyRefDef;
  [key: string]: any;
}

/**
 * Availability composer function
 * @param state
 */
export const Availability = (state): AvailabilityDef => {
  return Object.assign(
    {},
    state,
    { property: PropertyRef(state.property) },
    // composers
    withIdRetrieval(),
    withUoms(),
    withData(),
    withCompanyContacts(),
    withAssociationMedia(),
    withPrimaryImage()
  );
};

/**
 * Availability type enum
 */
export enum AvailabilityType {
  Lease = 'Lease',
  SaleOrLease = 'Sale or Lease',
}
